import { Notifications } from '@yuno/types'
import { useEffect, useState } from 'react'
import type { UseQueryResult } from 'react-query'
import {
  useGetNotificationsNumberMutation,
  useGetNotificationsCustomer,
  usePathNotifications,
} from '@yuno/dashboard-api-mfe'
import { useLogout } from '../../../account-menu/hooks'
import { notificationsType } from '../../../../utils/constants'

export const useNotifications = ({ customer, open, openReports }) => {
  const [newNotifications, setNewNotifications] = useState(0)
  const [notifications, setNotifications] = useState([])
  const { isNotAuth } = useLogout()
  const response: UseQueryResult<Notifications.INotificationsResponse> =
    useGetNotificationsCustomer(customer)

  const notificationsNumber: UseQueryResult<Notifications.INotificationsResponse> =
    useGetNotificationsNumberMutation()
  const pathNotificationMutation = usePathNotifications()

  useEffect(() => {
    isNotAuth(notificationsNumber?.data)
    if (!open && !openReports && notificationsNumber?.data) {
      setNewNotifications(notificationsNumber.data?.notifications_not_checked)
    }
  }, [notifications, notificationsNumber])

  const changeState = async (
    type = notificationsType.global,
    setNotificationNumber,
  ) => {
    const response = await pathNotificationMutation.mutateAsync({ type })
    const notificationNotChecked = response?.notifications_not_checked

    setNotificationNumber(notificationNotChecked || 0)
  }

  // This comment is to remove network loop
  // useEffect(() => {
  //   if (mutation.isSuccess && !notificationsNumber?.data?.code) {
  //     notificationsNumber.refetch()
  //   }
  // }, [mutation.isSuccess, notificationsNumber])

  useEffect(() => {
    isNotAuth(response?.data)
    if (response && response.data && !response?.data?.code) {
      setNotifications(response.data.content)
    }
  }, [response])

  return {
    errorNotification: notificationsNumber.error,
    newNotifications,
    notifications,
    changeState,
    loadingNumber: notificationsNumber.isLoading,
    refetchNumber: notificationsNumber.mutate,
    refetchNotifications: response.refetch,
  }
}
